"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysFromNow = void 0;
const daysBetween_1 = __importDefault(require("../daysBetween"));
exports.daysFromNow = (dateTime) => Math.abs(daysBetween_1.default(Date.now(), dateTime));
exports.default = exports.daysFromNow;
